module.exports = __webpack_public_path__ + "static/img/login_background_new.2d75e47b.jpg";